import React, {useState} from 'react'
import SelectPhotos from './SelectPhotos'
import ConfirmPhotos from './ConfirmPhotos'
import './index.scss'

const ProvideInput = (props) => {
  const [prevProductId, setPrevProductId] = useState(props.product.id)
  const [step, setStep] = useState('select')
  const [selectedPhotos, setSelectedPhotos] = useState([])

  if (props.product.id !== prevProductId) {
    setSelectedPhotos([])
    setPrevProductId(props.product.id)
  }

  const StepComponent = step === 'confirm' && selectedPhotos.length > 0
    ? ConfirmPhotos
    : SelectPhotos

  return (
    <StepComponent
      {...props}
      selectedPhotos={selectedPhotos}
      setSelectedPhotos={setSelectedPhotos}
      setStep={setStep}
    />
  )
}

export default ProvideInput
